import { render, staticRenderFns } from "./ConfigurarAlertas.vue?vue&type=template&id=43fb1f58&"
import script from "./ConfigurarAlertas.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarAlertas.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarAlertas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('43fb1f58', component.options)
    } else {
      api.reload('43fb1f58', component.options)
    }
    module.hot.accept("./ConfigurarAlertas.vue?vue&type=template&id=43fb1f58&", function () {
      api.rerender('43fb1f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/ConfigurarAlertas/ConfigurarAlertas.vue"
export default component.exports